import React, { Component } from "react";
import { connect } from "react-redux";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import { Bookmark, MapPin, ChevronRight, ChevronLeft } from "react-feather";
// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from "swiper/core";
import courseslogo from "../img/courses/courselogo.png";
import TrendingJobs1 from "../img/courses/course1.png";
import TrendingJobs2 from "../img/courses/course2.png";
import TrendingJobs3 from "../img/courses/course3.png";
import TrendingJobs4 from "../img/courses/course4.png";
import bookmark from "../img/bookmark.svg";
import { GetAllCourseAction } from "store/Ilearn";
import { Link } from "react-router-dom";
// install Swiper modules
SwiperCore.use([Pagination, Navigation]);

// export default function App()
class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      courses: [],
      isBookmarked: false,
    };
  }
  addDefaultSrc(ev) {
    ev.target.src = TrendingJobs1;
  }

  async componentDidMount() {
    try{
    // let response = await this.props.getAllCourses();
    // // console.log(response.data);
    
    // if (response.Data) {
    //   this.setState({ courses: response.Data });
    // }
  }
  catch (e) {
    //console.log(e)
  }
    // this.props.getAllCourses().then((res) =>{
    //   this.setState({ courses: res.data.Data });
    // })
    // .catch((err)=>console.log(err))
  }
  bookmark() {
    this.setState((state) => {
      // Important: read `state` instead of `this.state` when updating.
      return { isBookmarked: !state.isBookmarked };
    });
  }
  render() {
  //  const GETALLCOURSE = this.state.courses;
    const GETALLCOURSE = this.props.GETALLCOURSE||[];
    let state = this.state;
    const bookmark = () => this.bookmark();
    return (
      <>
        <div className="flex justify-between items-center  mb-8">
          <h2 className="fsize28 font-bold sm-fsize16">OUR COURSES</h2>
          <div className="flex ">
            <ChevronLeft
              width="30px"
              height="30px"
              className="trend-left-i mr-2"
            />
            <ChevronRight
              width="30px"
              height="30px"
              className="trend-right-i"
            />
          </div>
        </div>
        <Swiper
          breakpoints={{
            1366: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            991: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            425: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            375: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
          }}
          slidesPerGroup={4}
          // loop={true}
          loopFillGroupWithBlank={true}
          pagination={{
            clickable: true,
          }}
          navigation={false}
          className="mySwiper swiperpagination-dot"
        >
          {/* ////////////////////////////////////////////////////////////////////////////////////////////////// */}
          {GETALLCOURSE.map((course,index) => (
            <SwiperSlide className="shadow-lg rounded-12px mb-4 showcard" key={index}>
              <div className="img__wrap w-full">
                <div>
                  <div className="relative">
                    <img
                      onError={this.addDefaultSrc}
                      src={`${
                        process.env.REACT_APP_IMAGE_BASE_MG + course.c_path
                      }`}
                      className="sm-h126px   w-full rounded-t-lg h-222px  object-fill "
                      alt="banner-img "
                    />
                    {/* <div className="absolute bookmark-parent text-white rounded-full">
                      <img
                        src={bookmark}
                        alt="bookicon"
                        className="bookmark-t-c"
                      />
                    </div> */}
                    <div className="absolute bookmark-parent bookmark-icon-w text-white rounded-full cursor-pointer">
                      <Bookmark
                        width="20px"
                        height="20px"
                        className={
                          state.isBookmarked ? "bookmarked" : "text-white"
                        }
                        onClick={() => bookmark()}
                      />
                    </div>
                  </div>
                  <div className="relative">
                    <img
                      src={courseslogo}
                      alt="course"
                      className="courses-logo"
                    />
                    <div className="lg:px-8 md:px-8 lg:pt-12 md:pt-12 lg:pb-6 md:pb-6 px-4 pt-6 pb-4  ">
                      <p className="text-black text-left line-clamp-2 font-bold fsize20 sm-fsize12">
                        {course.c_title || "The Course"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="img__description_layer">
                  <h1 className=" img__description trend-hover-h sm-fsize11 ">
                    {course.c_category || "Human Resource"}
                  </h1>

                  <p className="text-black font-bold  lg:px-6 md:px-6  px-2  lg:my-6  md:my-6 my-2   fsize18 sm-fsize12 ">
                    {course.c_title || "The Course"}
                  </p>
                  <p className="cust-textmuted1 lg:px-8 md:px-8  fsize14  lg:mb-6 md:mb-6 mb-2 sm-fsize10">
                    {course.c_short_description || "this is short description"}
                  </p>
                  <p className="course-total flex justify-center px-6 fsize14  lg:mb-6 md:mb-6 mb-2  sm-fsize9">
                    <ul>
                      <li className="cust-list-bullet">6 Courses (12h)</li>
                    </ul>
                  </p>

                  <p className="text-black  lg:px-6 md:px-6 px-2 fsize14 font-medium sm-fsize9">
                    <span className="">
                      {" "}
                      {course.start_date && course.end_date
                        ? course.start_date + " - " + course.end_date
                        : "Forever"}
                    </span>
                  </p>

                  <div className="flex justify-center">
                    <button className="cust-trendapply-btn flex">
                      <Link
                        to={{
                          pathname:
                            process.env.PUBLIC_URL +
                            "/Career/ilearn-details/" +
                            course.c_courseId,
                          state: course.c_courseId,
                        }}
                        class="cust-trendapply-btn flex"
                      >
                        {" "}
                        ENROLL
                      </Link>{" "}
                    </button>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
          {/* //////////////////////////////////////////////////////////////////////////////////////////////// */}
        </Swiper>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    GETALLCOURSE: state.iLearn.course.ALLCOURSES?state.iLearn.course.ALLCOURSES.Data:[],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllCourses: async () => await dispatch(GetAllCourseAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
